import { IAddressModel, IGenericModelMapping, IVerifyAddressDtoRequest } from "lib-core-shared";

export class AddressRequestMappingModel implements IGenericModelMapping<IAddressModel, IVerifyAddressDtoRequest> {
    public toSourceTwoModel(model: IAddressModel): IVerifyAddressDtoRequest {
        return {
            addressLine1: model?.addressLine1,
            addressLine2: model?.addressLine2,
            countyState: model?.countyState,
            townCity: model?.townCity,
            country: model.countryName,
            countryCode: model.countryCode,
            postalCode: model?.postalCode
          } as IVerifyAddressDtoRequest
    }
    public toSourceOneModel(model: IVerifyAddressDtoRequest): IAddressModel {
        return {
            addressLine1: model?.addressLine1,
            addressLine2: model?.addressLine2,
            countyState: model?.countyState,
            townCity: model?.townCity,
            countryName: model.country,
            countryCode: model.countryCode,
            postalCode: model?.postalCode
          } as IAddressModel
    }
    public toSourceTwoModels(models: IAddressModel[]): IVerifyAddressDtoRequest[] {
        return models.map(model => this.toSourceTwoModel(model));
    }
    public toSourceOneModels(models: IVerifyAddressDtoRequest[]): IAddressModel[] {
        return models.map(model => this.toSourceOneModel(model));
    }
}